import { ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../../../sharedServices/utils.service';
import { ObservableManager } from '../../../types/observableManager.type';

@Component({
  selector: 'app-mu-form-password-checker',
  templateUrl: './mu-form-password-checker.component.html',
  styleUrls: ['./mu-form-password-checker.component.sass'],
})
export class MuFormPasswordCheckerComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;
  @Input() passwordCheckerName: string;
  @Input() passwordCheckerField: string;
  @Input() passwordCheckerParams: { [key: string]: string };
  @HostBinding('class') baseClass: string;
  private observableManager = new ObservableManager();

  constructor(
    private utilsService: UtilsService,
    private changeDetectorRef: ChangeDetectorRef,
    private translateService: TranslateService
  ) {
    this.baseClass = 'mu-password-checker';
  }

  ngOnInit(): void {
    if (!this.formGroup) {
      return environment.guardClause;
    }
    this.validate(this.formGroup.get(this.passwordCheckerField).value);
    this.observableManager.watch(this.formGroup.get(this.passwordCheckerField).valueChanges).subscribe(value => {
      this.validate(value);
    });
  }

  ngOnDestroy(): void {
    this.observableManager.release();
  }

  validate(password: string): void {
    if (!password || !this.formGroup) {
      return environment.guardClause;
    }
    this.changeDetectorRef.detectChanges();
    const validation = this.utilsService.validatePassword(password, this.passwordCheckerParams);
    this.formGroup.get(this.passwordCheckerName).updateValueAndValidity();
    this.formGroup.get(this.passwordCheckerName).setValue(validation.valid);

    if (this.formGroup.get('confirmPassword')?.value) {
      this.formGroup.get('confirmPassword').updateValueAndValidity();
    }

    document.getElementById('mu-password-checker-text').innerHTML = this.translateService.instant(
      'form.label.passwordCheck.' + (validation.strength !== 100 ? 'bad' : 'good')
    );
    const barElement = document.getElementById('mu-password-checker-bar-progress');
    const iconElement = document.getElementById('mu-password-checker-icon');

    barElement.style.width = validation.strength + '%';
    barElement.classList.remove('mu-background-green');
    iconElement.classList.remove('fa-check');
    iconElement.classList.remove('fa-warnign');
    iconElement.classList.add('fa-warning');

    if (validation.strength !== 100) {
      return environment.guardClause;
    }

    barElement.classList.add('mu-background-green');
    iconElement.classList.remove('fa-warning');
    iconElement.classList.add('fa-check');
  }
}
